import { render, staticRenderFns } from "./HomeworkPreview.vue?vue&type=template&id=2e53f8b6&scoped=true&"
import script from "./HomeworkPreview.vue?vue&type=script&lang=js&"
export * from "./HomeworkPreview.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkPreview.vue?vue&type=style&index=0&id=2e53f8b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e53f8b6",
  null
  
)

export default component.exports